var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCodeVerse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2048,
    height: 2048,
    viewBox: "0 0 2048 2048",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.385 801.188L701.691 258.759C817.456 145.678 1002.11 145.009 1118.69 257.249L1710.37 826.89C1831.88 943.871 1832.86 1138.07 1712.55 1256.28L1127.84 1830.8C1007.75 1948.79 814.036 1944.65 699.095 1821.65L136.833 1219.92C25.6671 1100.95 29.91 914.963 146.385 801.188Z",
    fill: "#0E85F2",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.299 803.274L777.879 332.86C893.644 219.779 1078.3 219.11 1194.88 331.349L1708.99 826.312C1830.5 943.294 1831.49 1137.49 1711.18 1255.7L1204.04 1754C1083.95 1871.99 890.235 1867.85 775.295 1744.84L286.746 1222C175.581 1103.03 179.824 917.049 296.299 803.274Z",
    fill: "#1E1E1E",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 919.16,
    cy: 1025.54,
    r: 512,
    fill: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 919.16,
    cy: 1025.54,
    r: 300,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441.66 799.094L1268.66 647.594L1066.16 774.094L1020.66 1547.59L1441.66 799.094Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.862 508.998L745.733 518.562L750.292 539.456L969.118 1542.4L973.839 1564.04H995.986H1210.49H1244.45L1237.38 1530.82L1021.06 513.375L1017.02 494.4L997.795 491.836L982.795 489.836L982.346 489.776L981.897 489.731L966.897 488.231L966.444 488.186L965.989 488.155L958.489 487.655L950.989 487.155L935.989 486.155L935.076 486.094H934.16H906.66H905.91L905.161 486.135L878.661 487.582L878.066 487.615L877.473 487.673L851.473 490.226L850.683 490.304L849.899 490.427L824.399 494.427L823.732 494.531L823.072 494.668L796.572 500.168L796.156 500.255L795.742 500.354L783.242 503.354L782.98 503.417L782.719 503.485L771.219 506.485L768.435 507.211L765.862 508.498L764.862 508.998Z",
    fill: "#0C8AFE",
    stroke: "#1E1E1E",
    strokeWidth: 55,
    strokeMiterlimit: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1350.17 1538L1754.34 527H1528.84L1130 1538L1350.17 1538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1350.17 1538L1754.34 527H1528.84L1130 1538L1350.17 1538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1293.67 1538L1701.34 527L1445.34 527L1073 1538L1293.67 1538Z",
    fill: "#0C8AFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1293.67 1538L1701.34 527L1445.34 527L1073 1538L1293.67 1538Z",
    fill: "#0C8AFE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_2",
    x: 403.16,
    y: 513.542,
    width: 1032,
    height: 1032,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_2",
    x: 1069,
    y: 527,
    width: 636.34,
    height: 1019,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2048,
    height: 2048,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeVerse);
export default __webpack_public_path__ + "static/media/code-verse.50f42c9219fa48eecbd498c6656d09a5.svg";
export { ForwardRef as ReactComponent };